(function () {
  angular.module('MktzapApp.Controllers')
    .controller('JobsQueueController', jobsQueueController);

  jobsQueueController.$inject = ['JobsQueueService', 'NotificationService'];

  function jobsQueueController (JobsQueueService, NotificationService) {
    var vmJobsQueueCtrl = this;
    vmJobsQueueCtrl.queues = {};

    JobsQueueService
      .getAllJobsQueue()
      .$promise
      .then(function (data) {
        vmJobsQueueCtrl.queues = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, 'Ocorreu um erro ao carregar a fila de jobs');
      });
  }
})();
